export default __webpack_public_path__ + "static/media/team.08fb4de4.png";